// tab ids
const NEW_TAB_ID = 'review'; // making changes for vfto 849
const PEER_TAB_ID = 'peer';
const APPROVAL_TAB_ID = 'approval';
// const REJECTED_TAB_ID = 'rejected'; // making changes for vfto 849
const CIRCUITCHECK_TAB_ID = 'circuitchecks';
const PRECLOSURE_TAB_ID = 'preclosure';
const EMERGENCY_TAB_ID = 'emergency';



const DEFAULT_TAB = NEW_TAB_ID;

export {
  NEW_TAB_ID,
  PEER_TAB_ID,
  CIRCUITCHECK_TAB_ID,
  APPROVAL_TAB_ID,
  // REJECTED_TAB_ID,
  DEFAULT_TAB,
  PRECLOSURE_TAB_ID,
  EMERGENCY_TAB_ID,
};
